import React, { useState, useRef } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import {
  AiOutlineDelete,
  AiOutlineClose,
  AiOutlineReconciliation,
} from "react-icons/ai";
// import { LuHome } from "react-icons/lu";
import { RiRobot2Line } from "react-icons/ri";
import {
  MdClose,
  MdLogout,
  MdOutlineCorporateFare,
  MdOutlineQuestionAnswer,
} from "react-icons/md";
import { MeetingCreationForm } from "../dashboard/MeetingCreation";
import {
  EnrolledCourses,
  RadialBarChart,
  ReferAndEarnCard,
  UserDetails,
} from "../dashboard/dashboard";
import { MdOutlineCancel } from "react-icons/md";
import CreateMockTest from "../mockTest/CreateMockTest";
import { useObserver } from "mobx-react";
import { useEffect } from "react";
import { useStores } from "../../store";
import HelpCenter from "../reusble_components/helpCenter";
import { ListCourses } from "../dashboard/learn";
import BasicDetails, { GetMoreCreditsPopUp } from "../dashboard/basicDetails";
import { RedeemCoupon } from "../dashboard/basicDetails";
import { PurchaseCredits } from "../dashboard/creditPoints";
import ReferAndEarn from "../dashboard/ReferAndEarn";
import KnowMore from "../dashboard/knowMore";
import TopicBasedInterview from "../dashboard/topicBasedInterview";
import Create, { InterviewList } from "../dashboard/create";
import ResumeCard from "../dashboard/ResumeCard";
import { ProfilePic } from "../dashboard/profilePic";
import { getLogoBySubdomain, name, view } from "../../services/white_label";
import { showNewUi } from "../../helpers/constantVariables";
import { EnrolledCoursesProgressBar1 } from "../dashboard/learn1";
import { SearchBarMobile } from "../dashboard/SearchBar";
import { FaCode } from "react-icons/fa";
import FreeInterviews from "../FreeInterviews";
import "../../index.css";
import Notification from "../dashboard/Notification";
import ResumeDetails from "../resume1/resumeDetails";
import {
  IoDiamondOutline,
  IoDocumentTextOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import CareerLanding from "../career/careerLanding";
import CareerDetails from "../career/CareerDetails";
import Career from "../dashboard/Career";
import { apiPostPut } from "../../api/api_methods";
import QuizCard from "../dashboard/quizCard";
import History from "../dashboard/history";
import Internship from "../career/JobInternship";
import JobDetails from "../career/components/page";
import errorImage from "../../assests/under-construction.png";
import FacingProblem from "../dashboard/facingProblem";
import ReportScreen from "../reusble_components/reportScreen";
import LearninngTab from "../learn/learningTab";
import ResumeTotal from "../resume/resumetotal";
import TermsAndConditionsPopup from "../dashboard/termsAndConditionsPopup";
// import jobFairIcon from "../../assests/JobFairIcon.svg";
import Connect from "../dashboard/Connect";
import HistoryPage from "../career/HistoryPage";
import { IoMdShare } from "react-icons/io";
import DeletePopup from "../recruiter/DeletePopup";
import ResponsiveHeader from "../reusble_components/labels3/responsiveHeader";
import { SlSpeech } from "react-icons/sl";
import { VscHistory, VscHubot } from "react-icons/vsc";
import { BsPersonWorkspace } from "react-icons/bs";
import { HiOutlineBriefcase, HiOutlineUsers } from "react-icons/hi2";
import ConfirmationPopup from "../reusble_components/profile/confirmationpopup";
import ProgressBar from "../reusble_components/profileProgress";
import ResumeAnalyzer from "../dashboard/resume/resumeAnalyzer";
import Subscription from "../reusble_components/Pricing/subscription";
import PricingPlan from "../reusble_components/Pricing/pricePlans";
import { ImSortAmountAsc } from "react-icons/im";
import TransactionCards from "../reusble_components/Pricing/transactionCards";
import { GoHome } from "react-icons/go";
import { PiSuitcaseSimpleLight } from "react-icons/pi";
import { LiaChevronCircleRightSolid } from "react-icons/lia";
import MockExamReport from "../dashboard/mockexamreport";
import Report from "../dashboard/resume/report";
import CheckoutPage from "../reusble_components/Pricing/naukritube/CheckoutPage.jsx";
const MobileBottomNavBar = () => {
  const [isopen, setIsopen] = useState(true);
  const listCourseRef = useRef(null);
  const [studentDetails, setstudentDetails] = useState("");
  const { CommonStore, PopupStore, RecuiterStore } = useStores();
  const [banner, setBanner] = useState(null);
  // const [isOpen, setIsOpen] = useState(true);

  const [showPopup, setShowPopup] = useState(false);

  const userLogOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/login");
  };

  const { UserStore } = useStores();
  const [showTechFusionHeader, setShowTechFusionHeader] = useState(false);

  useEffect(() => {
    UserStore.fetchDashboardInterviews();
    getStudentDetails();
    getbanner();
  }, []);
  const getbanner = async () => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("user"));
      const data = {
        clusterId: userDetails?.cluster,
      };
      const response = await apiPostPut(
        data,
        "/admin/get-active-banner?usedFor=student",
        "POST",
      );
      if (response.status === 200) {
        // console.log("response", response.body.data);
        console.log("response", response.body.data);
        if (response.body.data < 0) {
          setShowTechFusionHeader(false);
        } else {
          setBanner(response.body.data);
          setShowTechFusionHeader(true);
        }
      } else {
        setShowTechFusionHeader(false);
      }
    } catch (error) {
      console.error("Failed to fetch banner:", error);
      setShowTechFusionHeader(false);
    }
  };

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/dashboard/dashboard") {
      CommonStore.setBottomNavigationIndex(0);
    }
    if (location.pathname === "/dashboard/learn") {
      CommonStore.setBottomNavigationIndex(2);
    }
    if (location.pathname === "/dashboard/resumedetails") {
      CommonStore.setBottomNavigationIndex(7);
    }
    if (location.pathname === "/dashboard/settings") {
      CommonStore.setBottomNavigationIndex(3);
    }
    if (location.pathname === "/dashboard/jobinternship") {
      CommonStore.setBottomNavigationIndex(8);
    }
    if (location.pathname === "/dashboard/myapplicants") {
      CommonStore.setBottomNavigationIndex(12);
    }
  }, [location.pathname]);

  const logOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/login");
  };
  const getStudentDetails = async () => {
    try {
      let studentDetails = await JSON.parse(localStorage.getItem("user"));
      setstudentDetails(studentDetails);
      let google_user = await JSON.parse(localStorage.getItem("user_google"));
      // setPic(google_user?.picture);
    } catch (error) {
      console.log(error);
    }
  };

  const profile = () => {
    return (
      <div className="overflow-y-hidden overflow-x-hidden  max-w-full mb-[10px] pt-[20px] mt-10 ">
        {UserStore.DeletePopup ? <DeletePopup /> : null}
        <div className="flex items-center justify-start  bg-[#FBF7F2] ">
          <div className="flex flex-row items-center w-[70%] ml-[5%] mt-10">
            <div className="top-4 relative">
              <ProfilePic />
            </div>

            <div className="flex flex-col ml-[5%]">
              <h1 className="text-md mt-6 text-centerfont-[400] text-[#000000]">
                {UserStore?.userDetails?.name}
              </h1>
              <p className="text-xs opacity-60  leading-[20px] text-[#FF6B00]">
                {UserStore?.userDetails?.mail}
              </p>
              {/* <p className="text-xs opacity-60 text-text_color3 leading-[20px]">
                {UserStore?.userDetails?.role?.role}
              </p> */}
            </div>
          </div>
          <div className="flex mt-24 ml-10 ">
            <button
              className="flex justify-center items-center  text-primary  rounded-lg mr-2"
              onClick={() => PopupStore.setReferAndEarn(true)}
            >
              <IoMdShare />
            </button>
            <button
              className="flex justify-center items-center  text-primary  rounded-lg mr-2 "
              onClick={() => setShowPopup(true)}
            >
              <MdLogout />
            </button>

            {showPopup && (
              <ConfirmationPopup
                message="Do you really want to log out?"
                cancelButton="Yes, Logout"
                onClick={() => setShowPopup(false)}
                onConfirm={userLogOut}
                onCancel={() => setShowPopup(false)}
              />
            )}

            {/* <button
              className="flex justify-center items-center  text-[#FF0000] rounded-lg mr-3"
              onClick={() => UserStore.setDeletePopup(true)}
            >
              <AiOutlineDelete />
            </button> */}
          </div>
          {/* <div className="w-[15%] ml">
            <button
              type="submit"
              onClick={() => logOut()}
              // onClick={handleUpdateClick}
              className="bg-primary  text-white h-10 w-[23vw] rounded-xl lg:w-fit lg:h-fit mx-5 ml-[4rem]"
            >
              <p className="lg:py-4 lg:px-24"> Log out</p>
            </button>
          </div> */}
        </div>
        <BasicDetails
          onSave={() => {
            scrollToTop();
            CommonStore.setBottomNavigationIndex(0);
          }}
        />
        {/* <button
          onClick={() => logOut()}
          class="mx-auto my-3 w-[70%] ml-[15%] bg-white text-red-700 font-bold py-2 px-4 border border-red-700 rounded"
        >
          Logout
        </button> */}
      </div>
    );
  };

  const comingSoon = () => {
    return (
      <div className="bg-primary text-white h-[100%] flex flex-col justify-center items-center">
        <h1 className="text-4xl font-bold mb-4">Coming Soon</h1>
        <p className="text-lg mb-8">Our website is under construction.</p>
        <p className="text-lg">Stay tuned for `update`s!</p>
      </div>
    );
  };
  const learn = () => {
    return (
      <div className=" ml-[-20px] mb-20 mt-12">
        <div className="pb-4 w-[80%]">
          <SearchBarMobile value="Search by course"></SearchBarMobile>
        </div>

        <div className="">
          <h1 className="text-3xl ml-[40px] ">Enrollment Courses</h1>
          <EnrolledCoursesProgressBar1></EnrolledCoursesProgressBar1>
        </div>
        <div className="mt-[5%]">
          <h2 className="text-3xl ml-[40px] ">Select course to Enroll</h2>
          <div
            className="flex items-center justify-center "
            ref={listCourseRef}
          >
            <ListCourses />
          </div>
        </div>
      </div>
    );
  };
  const navigate = useNavigate();
  // const dashboardref=useRef(null);

  const scrollToTop = () => {
    // scroll to top by id
    try {
      const element = document.getElementById("mobile-header");
      element.scrollIntoView({ behavior: "instant" });
    } catch (error) {}
  };

  const openGoogleForms = () => {
    window.location.href = banner.link;
  };

  const userGoogleDetails = JSON.parse(localStorage.getItem("user"));
  const [profile1, setProfile1] = useState(userGoogleDetails?.pic);

  useEffect(() => {
    if (UserStore.userPic) {
      setProfile1(UserStore.userPic);
    } else {
      setProfile1(userGoogleDetails?.pic);
    }
  }, [UserStore.userPic]);

  useEffect(() => {
    setProfile1(userGoogleDetails?.pic);
  }, []);

  const defaultProfile =
    "https://t4.ftcdn.net/jpg/02/15/84/43/360_F_215844325_ttX9YiIIyeaR7Ne6EaLLjMAmy4GvPC69.jpg";

  const handleCloseTechFusionHeader = () => {
    setShowTechFusionHeader(false);
  };

  const handleButtonClick = () => {
    // Navigate to the desired route
    navigate("/dashboard/mocktest");
  };
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const startX = useRef(null);

  const cards = [
    // <div className="w-full">
    //   <ResumeCard />
    // </div>,
    // <div className="w-full">
    //   <div className="flex justify-center items-center rounded-2xl h-full py-10 mx-2.5 bg-primary2">
    //     <div className="flex flex-col mr-9">
    //       <p className="text-black text-xl">Mock Test</p>
    //       <p className="text-gray-500">Take your test now</p>
    //       <button
    //         className="mt-2 hover:bg-primary border-primary border px-3 py-2 flex items-center rounded-xl justify-center"
    //         onClick={() => console.log("Mock Test clicked")}
    //       >
    //         <FaArrowRight />
    //       </button>
    //     </div>
    //     <div className="bg-primary2 rounded-md p-5 h-auto">
    //       <img src={Test} alt="resumecard" className="h-20 w-20 object-fit" />
    //     </div>
    //   </div>
    // </div>,
    // <div className="w-full">
    //   <QuizCard />
    // </div>,
  ];

  // Auto-scroll effect with pause functionality
  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % cards.length);
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [cards.length, isPaused]);

  // Handle dot click to navigate and pause auto-scroll
  const handleDotClick = (index) => {
    setCurrentIndex(index);
    setIsPaused(true); // Pause auto-scroll
    setTimeout(() => setIsPaused(false), 2000); // Resume after 2 seconds
  };

  // Touch event handlers
  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    const deltaX = startX.current - endX;

    if (deltaX > 50) {
      // Swiped left
      setCurrentIndex((prevIndex) => (prevIndex + 1) % cards.length);
      setIsPaused(true);
      setTimeout(() => setIsPaused(false), 2000);
    } else if (deltaX < -50) {
      // Swiped right
      setCurrentIndex(
        (prevIndex) => (prevIndex - 1 + cards.length) % cards.length,
      );
      setIsPaused(true);
      setTimeout(() => setIsPaused(false), 2000);
    }
  };
  const freeInterviews = [
    {
      title: "Technical Mock Interview",
      id: 2, // interview id // 2 is with resume 1 is without resume
      sort: 1,
      description:
        "Mock practice at 60% efficiency builds a solid foundation, boosting confidence and enabling initial self-assessment.",
      active: true,
      type: "basic",
      company: true,
      icon: <HiOutlineBriefcase />,
    },
    // {
    //   img: <AiOutlineFileDone />,
    //   title: "Resume Based Interview",

    //   id: 2, // interview id
    //   sort: 3,
    //   description:
    //     "Efficient Initial Screening: A resume interview efficiently screens candidates based on their resume, providing a quick assessment of qualifications and potential alignment with the job.",
    //   active: true,
    //   type: "resume",
    // },
    {
      // img: <BsBuildings />,
      title: "Company Specific Interview",
      id: 4, // interview id // 4 is with resume  3 is without resume
      sort: 4,
      description:
        "The company’s interview process efficiently evaluates candidates' skills and cultural fit through diverse formats.",
      active: true,
      type: "company",
      icon: <MdOutlineCorporateFare className="w-8 h-8" />,
    },
    // {
    //   img: <BsBuildingCheck />,
    //   title: "Company Interview with Resume",
    //   id: 4, // interview id
    //   sort: 5,
    //   description:
    //     "Efficient Comprehensive Assessment: Combining traditional elements with a resume-based evaluation, this interview efficiently assesses a candidate's background and alignment with the company's needs and culture.",
    //   active: true,
    //   type: "resume, company",
    // },
    {
      img: <BsPersonWorkspace />,
      title: "HR Interview",
      id: 8, // interview id // 8 is with resume  5 is without resume
      sort: 6,
      description:
        "HR interview efficiently screens candidates, quickly assessing qualifications and potential job alignment based on resumes.",
      active: true,
      company: true,
      icon: <HiOutlineUsers className="w-8 h-8" />,
    },
    {
      img: <BsPersonWorkspace />,
      title: "Coding Interview",
      id: 10, // interview id // 10 is with resume  5 is without resume
      sort: 6,
      description:
        "A coding interview assesses programming skills and problem-solving through technical challenges.",
      active: true,
      company: true,
      icon: <FaCode />,
    },
    {
      img: <RiRobot2Line />,
      title: "English Practice Bot",
      id: 6, // interview id
      sort: 8,
      description:
        "English Practice Bot helps improve speaking skills by asking questions, providing feedback on your answers.",
      active: true,
      icon: <VscHubot className="w-14 h-14" />,
    },
    {
      img: <MdOutlineQuestionAnswer />,
      title: "Viva Interview",
      id: 9, // interview id
      sort: 7,
      description:
        "The company's interview process efficiently assesses skills and cultural fit through diverse formats.",
      active: true,
      icon: <SlSpeech />,
    },
    {
      img: <AiOutlineReconciliation />,
      title: "MCQ's Test",
      id: "mcq", // interview id
      sort: 9,
      description:
        "An online MCQ test assesses cognitive abilities, problem-solving skills, and technical knowledge through a series of multiple-choice questions.",
      active: true,
      icon: <AiOutlineReconciliation />,
    },
    {
      img: <ImSortAmountAsc />,
      title: "Resume Analyzer",
      id: "resumeSort", // interview id
      sort: 10,
      description:
        "A resume analyzer scans and evaluates resumes to match key skills and qualifications with job requirements.",
      active: true,
      icon: <ImSortAmountAsc />,
    },
  ];

  const [showprogress, setShowProgress] = useState(true);
  const getProgress = () => {
    const user = JSON.parse(localStorage.getItem("user")) || {};

    // Ensure dob is a string before trimming
    const basic =
      user.name?.trim().length > 0 &&
      String(user.dob || "").trim().length > 0 && // Convert to string safely
      user.gender?.trim().length > 0 &&
      user.bio?.trim().length > 0 &&
      (typeof user.resume === "string" ? user.resume.trim().length > 0 : false); // Checking resume

    const skills = Array.isArray(user.skills) && user.skills.length > 0;

    const contact = user?.linkedIn?.trim().length > 0 && user?.mobile;

    const experience =
      (Array.isArray(user.previousCompanies) &&
        user.previousCompanies.length > 0) ||
      (user.currentCompany && user.currentCompany.trim().length > 0);

    let data = [
      {
        label: "Basic ",
        completed: basic,
        label2: "Basic ",
        show: true,
      },
      {
        label: "Skills",
        completed: skills,
        label2: "Skills",
        show: true,
      },
      {
        label: "Contact ",
        completed: contact,
        label2: "Contact ",
        show: true,
      },
      {
        label: "Experience",
        completed: experience,
        label2: "Experience",
        show: true,
      },
    ];

    console.log(data);
    return data;
  };

  const [activePlan, setActivePlan] = useState(null);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      await UserStore.checkSubscription();
      console.log("subscriptions3333", UserStore.previousSubscriptions);
      if (!Array.isArray(UserStore.previousSubscriptions)) {
        // navigate("/dashboard/subscription");
      } else {
        const activeSubscription = UserStore.previousSubscriptions?.find(
          (sub) => sub.isActivated,
        );
        setActivePlan(activeSubscription);
      }
    };

    fetchSubscriptions();
  }, []);

  const studentPlans = [
    {
      id: "67cac81dcc2bec83fe4e8a95",
      name: "Basic Plan",
      price: 599,
      originalPrice: "₹999",
      features: [
        { text: "Resume Analyser", available: true, value: 3 },
        { text: "AI Interviews", available: true, value: 3 },
        { text: "Internship Guarantee", available: false },
        { text: "Detailed Analytical Report", available: true },
        { text: "Days Interview Video Backup", available: true, value: 15 },
        { text: "Job Application", available: true, value: 1 },
        { text: "Profile Boost", available: false },
        { text: "Premium Account Badge", available: false },
        { text: "MCQ's", available: true, value: 3 },
        { text: "Days Validity", available: false, value: 30 },
        { text: "Alerts & Notifications", available: false },
        { text: "ATS", available: false },
        { text: "Performance Analytical Report", available: false },
      ],
    },
    {
      id: "67caca7ecc2bec83fe4e8aa4",
      name: "Starter Plan",
      price: 5999,
      originalPrice: "₹5,999",
      features: [
        { text: "Resume Analyser", available: true, value: 50 },
        { text: "AI Interviews", available: true, value: 50 },
        { text: "Internship Guarantee", available: false },
        { text: "Detailed Analytical Report", available: true },
        { text: "Days Interview Video Backup", available: true, value: 30 },
        { text: "Job Application", available: true, value: 30 },
        { text: "Profile Boost", available: true },
        { text: "Premium Account Badge", available: false },
        { text: "MCQ's", available: true, value: 30 },
        { text: "Days Validity", available: true, value: 365 },
        { text: "Alerts & Notifications", available: true },
        { text: "ATS", available: true },
        { text: "Performance Analytical Report", available: true },
      ],
    },
    {
      id: "67cacdd8cc2bec83fe4e8ab3",
      name: "Advanced Plan",
      price: 7999,
      originalPrice: "₹8,499",
      features: [
        { text: "Resume Analyser", available: true, value: "∞" },
        { text: "AI Interviews", available: true, value: "∞" },
        { text: "Internship Guarantee", available: true, bold: true },
        { text: "Detailed Analytical Report", available: true },
        { text: "Days Interview Video Backup", available: true, value: 60 },
        { text: "Unlimited Job Application", available: true },
        { text: "Profile Boost", available: true },
        { text: "Premium Account Badge", available: true },
        { text: "MCQ's", available: true, value: "∞" },
        { text: "Days Validity", available: true, value: 365 },
        { text: "Alerts & Notification", available: true },
        { text: "ATS", available: true },
        { text: "Performance Analytical Report", available: true },
      ],
    },
    {
      id: 2,
      name: "Custom Plan",
      price: 0,
      // originalPrice: "₹18,499",
      features: [
        { text: "Resume Analyser", available: true },
        { text: "AI Interviews", available: true },
        { text: "Reports", available: true },
        { text: "ATS Dashboard", available: true },
        { text: "Tags", available: true },
        { text: "Salary recommendation", available: true },
        { text: "Proxy detection", available: true },
        { text: "Job Post", available: true },
        { text: "MCQ's", available: true },
        { text: "Login", available: true, value: 10 },
        { text: "Day Interview Backup", available: true },
        { text: "In App Auto Emails", available: true },
        { text: "White Labelling", available: true },
        { text: "Shared Support", available: true },
      ],
    },
  ];

  const calculateCompletionPercentage = () => {
    const data = getProgress();
    const totalItems = data.length;
    const completedItems = data.filter((item) => item.completed).length;
    const percentage = (completedItems / totalItems) * 100;
    if (percentage === 100) {
      setShowProgress(false);
    }
    return percentage.toFixed(0);
  };
  const [filteredList, setFilteredList] = useState(freeInterviews);
  const home = () => {
    return (
      <div className="bg-white w-[100vw] flex flex-col items-center relative justify-between mt-[10%] h-fit rounded-[13px] mb-20   ">
        {showNewUi ? (
          <>
            {/* <header className="w-full">
              {showTechFusionHeader && (
                <div
                  className="bg-bg2 text-white py-1 mt-5 flex items-center w-full justify-center px-[5%]"
                  style={{
                    backgroundImage: `${banner?.backgroundColor}`,
                  }}
                >
                  <img
                    src={banner?.image}
                    className="w-6 h-6 mr-4 "
                    alt="banner image"
                  />
                  <p className=" text-[10px] ">
                    <span className="font-semibold">{banner?.content} </span>
                    <a
                      onClick={openGoogleForms}
                      className="cursor-pointer underline font-semibold px-1"
                    >
                      {banner?.buttonLabel}
                    </a>{" "}
                  </p>

                  <button onClick={handleCloseTechFusionHeader}>
                    <MdOutlineCancel className="ml-1 text-lg text-white cursor-pointer" />
                  </button>
                </div>
              )}
            </header> */}
            <div className="pb-4 w-[80%]">
              <SearchBarMobile value="Search by course"></SearchBarMobile>
            </div>
            {/* <div className="bg-[#ff6b00]  mb-12 w-[90%] h-[25%] py-5 gap-2 flex px-5  justify-start  text-white mx-auto rounded-xl">
              <img
                src={jobFairIcon}
                className="w-[40%] bg-transparent object-contain"
                alt=""
              />
              <div className="w-full h-fit my-auto">
                <h1 className="font-normal text-lg">
                  AI- Powered Online <br />{" "}
                  <h1 className="font-extrabold">Job Fair</h1>{" "}
                </h1>
                <p className="font-bold w-full text-[9px] mt-2 h-full ">
                  Register now for the chance with network with recruiters and
                  land in your next big role.
                </p>
                <button
                  onClick={() => {
                    UserStore.setTermsAndConditionsPopup(true);
                  }}
                  className="bg-white text-primary w-[80%] px-5 h-10  rounded-lg font-medium mt-4 "
                >
                  {" "}
                  Register{" "}
                </button>
              </div>
            </div> */}
            <TermsAndConditionsPopup />
            {/* <Carousel /> */}
            {!isopen && (
              <div
                className="bg-primary md:hidden z-50 py-4 px-2 gap-2 w-full h-12 text-center justify-center items-center flex flex-row"
                onClick={() => {
                  if (name() !== "Naukritube") {
                    navigate("/dashboard/subscription");
                  } else {
                    navigate("/dashboard/pricing-plans1");
                  }
                }}
              >
                <IoDiamondOutline className="text-2xl text-white" />
                <p className="text-xl font-medium text-white">Try Premium</p>
                <LiaChevronCircleRightSolid className="text-white text-2xl" />
              </div>
            )}

            <div className="w-[90%] mt-[3%]  ">
              <ResponsiveHeader
                title={"Home Page"}
                showButton={false}
                showDropdown={false}
                handleInputChange={(event) => {
                  const searchValue = event.target.value.toLowerCase(); // Get the input value
                  const filteredData = freeInterviews.filter((interview) =>
                    interview.title.toLowerCase().includes(searchValue),
                  );
                  setFilteredList(filteredData); // Update the state

                  // Logging inside useEffect ensures it logs after state updates
                  console.log("Filtered List:", filteredData);
                }}
              />

              {isopen && (
                <div className="bg-black relative w-full md:hidden flex flex-col p-4 my-4 rounded-lg">
                  <button
                    onClick={() => setIsopen(false)}
                    className="absolute -top-2 -right-1 text-white bg-primary  hover:bg-gray-600 rounded-full p-1"
                  >
                    <MdClose />
                  </button>
                  <div className="flex flex-row items-center justify-start text-primary gap-3">
                    <IoDiamondOutline className="text-primary text-3xl" />
                    <p className="text-2xl gil-med">Try Premium</p>
                  </div>
                  <div>
                    <p className="text-gray-100 mt-2">
                      Unlock AI-powered job matching, unlimited interviews,
                      priority access, and enhanced visibility to land your
                      dream job faster with Reaidy Premium! 🚀
                    </p>
                  </div>
                  <div>
                    <button
                      className="bg-primary text-white w-auto text-sm py-2 px-4 rounded-lg mt-4"
                      onClick={() => {
                        // if (activePlan) {
                        //   alert(
                        //     "You are already subscribed to a " +
                        //       activePlan.planId.name
                        //   );
                        //   return;
                        // }
                        if (name() !== "Naukritube") {
                          navigate("/dashboard/subscription");
                        } else {
                          navigate("/dashboard/pricing-plans1");
                        }
                      }}
                    >
                      Upgrade to Premium
                    </button>
                  </div>
                </div>
              )}

              {showprogress && (
                <ProgressBar
                  commingFrom={"student"}
                  steps={getProgress()}
                  percentage={calculateCompletionPercentage()}
                  buttonName="Complete Profile"
                  buttonAction={() => {
                    alert("Complete Profile button clicked!");
                  }}
                  description="Complete your profile to unlock full functionality and enhance your career opportunities."
                  closeIcon={
                    <AiOutlineClose className="text-white text-md rounded-full cursor-pointer bg-primary" />
                  }
                  onClose={() => setShowProgress(false)}
                />
              )}
              <div className="w-full">
                <p className="font-semibold text-lg ml-3 text-primary mt-6">
                  Services We Offer
                </p>
                <FreeInterviews completed={5} total={5} />
              </div>
              {/* <button className=" flex bg-primary text-white text-sm  py-2 px-4 rounded-lg  -mt-8 gap-1 ml-auto ">
                <CiCirclePlus className="w-5 h-5 " />

                <p>Create new</p>
              </button> */}

              <div className="w-full">
                <InterviewList freeInterviews={filteredList} />
              </div>
            </div>
            {isopen && (
              <div
                className="relative w-full overflow-hidden mt-5"
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
              >
                <button
                  onClick={() => setIsopen(false)}
                  className="absolute -top-2 -right-1 text-white bg-primary  hover:bg-gray-600 rounded-full p-1"
                >
                  <MdClose />
                </button>
                <div
                  className="flex transition-transform ease-in-out duration-500"
                  style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                >
                  {cards.map((card, index) => (
                    <div
                      key={index}
                      className="w-full flex-shrink-0"
                      style={{ width: "100vw" }}
                    >
                      {card}
                    </div>
                  ))}
                </div>

                {/* Dots for navigation */}
                <div className="flex justify-center absolute bottom-2 left-[45%]">
                  {cards.map((_, index) => (
                    <span
                      key={index}
                      className={`h-2 w-2 rounded-full mx-1 cursor-pointer ${
                        currentIndex === index ? "bg-primary" : "bg-gray-400"
                      }`}
                      onClick={() => handleDotClick(index)}
                    />
                  ))}
                </div>
              </div>
            )}

            {/* <IoTCard /> */}
          </>
        ) : (
          <>
            <div className=" h-fit w-full  flex flex-col pt-16 ">
              <UserDetails
                from="mobile"
                onclickEdit={() => {
                  CommonStore.setBottomNavigationIndex(3);
                }}
              />

              <div className="flex flex-col w-full items-start ml-[-10px]">
                <EnrolledCourses
                  onClickEmptyEnroll={() => {
                    CommonStore.setBottomNavigationIndex(2);
                  }}
                />
              </div>
            </div>
            <div className="flex flex-col w-full ml-[-5px]">
              <p className="text-[20px] text-black ml-7">
                Skills based on Recent Interviews
              </p>
              <div className=" flex flex-row gap-10 items-center overflow-x-auto no-scrollbar overflow-hidden w-[90%] ml-7">
                <RadialBarChart
                  score={UserStore.userDetails?.technicalSkills ?? 0}
                  label={"Technical skills"}
                />
                <RadialBarChart
                  score={UserStore.userDetails?.communicationSkills ?? 0}
                  label={"Communication skills"}
                />
                <RadialBarChart
                  score={UserStore.userDetails?.overallRating ?? 0}
                  label={"Overall Score"}
                />
              </div>
            </div>
            <ResumeCard />
            <div className="m-2">
              <QuizCard />
            </div>
            <ReferAndEarnCard onClick={scrollToTop} shadow={true} />
            <RedeemCoupon onClick={scrollToTop} InitialvalueofShow={true} />
          </>
        )}
        <div className="mt-4" />
      </div>
    );
  };

  return useObserver(() => (
    <div
      className={`h-screen w-screen rounded fixed bottom-0 left-0 bg-white border-gray-300 md:hidden shadow-lg gil-reg overflow-x-hidden no-scrollbar ${
        PopupStore.KnowMore ? "overflow-hidden" : "overflow-y-auto"
      }`}
    >
      {PopupStore.KnowMore && (
        <KnowMore
          popUpInitialValue={true}
          handlePopup={() => {
            PopupStore.setKnowMore(false);
          }}
        />
      )}
      {PopupStore.getMoreCredits && (
        <GetMoreCreditsPopUp
          popUpInitialValue={PopupStore.getMoreCredits}
          handlePopup={() => {
            PopupStore.setGetMoreCredits(false);
          }}
        />
      )}
      {PopupStore.notification && (
        <Notification
          popUpInitialValue={PopupStore.notification}
          handlePopup={() => {
            PopupStore.setNotification(false);
          }}
        />
      )}
      {PopupStore.connectPopup && <Connect />}
      {PopupStore.redeemCoupon && (
        <RedeemCoupon
          popUpInitialValue={true}
          handlePopup={() => {
            PopupStore.setRedeemCoupon(false);
          }}
        />
      )}

      {PopupStore.topicbasedinterview && (
        <TopicBasedInterview
          popUpInitialValue={PopupStore.topicbasedinterview}
          handlePopup={() => {
            PopupStore.setTopicBasedInterview(false);
          }}
        />
      )}

      {PopupStore.createinterview && (
        <Create
          popUpInitialValue={PopupStore.createinterview}
          handlePopup={() => {
            PopupStore.setCreateInterview(false);
          }}
        />
      )}

      {PopupStore.paymentGateway && (
        <PurchaseCredits
          gateWay="phonePe"
          onClose={() => {
            PopupStore.setPaymentGateway(false);
          }}
        />
      )}

      {PopupStore.referAndEarn && (
        <ReferAndEarn
          popUpInitialValue={true}
          handlePopup={() => {
            PopupStore.setReferAndEarn(false);
          }}
        />
      )}

      {PopupStore.facingProblem && (
        <FacingProblem
          popUpInitialValue={PopupStore.facingProblem}
          image={errorImage}
          closeThisPopUP={() => {
            PopupStore.setFaccingProblem(false);
          }}
        />
      )}

      <header
        className="shadow-lg fixed bg-white top-0 left-0 mt-0 ml-0 z-40 w-screen "
        id="mobile-header"
      >
        <>
          {showTechFusionHeader ? (
            <div
              className=" bg-black text-white py-1 lg:h-6 flex items-center justify-center !h-6"
              style={{
                backgroundImage: `${banner?.backgroundColor}`,
              }}
            >
              <img
                src={banner?.image}
                className="w-4 h-4 mr-4  "
                alt="banner image"
              />
              <p className=" text-xs lg:py-6">
                <span className="font-semibold">{banner?.content} </span>
                <a
                  onClick={openGoogleForms}
                  className="cursor-pointer underline font-semibold px-1"
                >
                  {banner?.buttonLabel}
                </a>{" "}
              </p>
              <button onClick={handleCloseTechFusionHeader}>
                <MdOutlineCancel className="ml-1 text-xs lg:text-lg text-white cursor-pointer" />
              </button>
              {/* <button className="ml-1 underline">View More</button> */}
            </div>
          ) : null}
        </>
        <div className=" mt-0 ml-0 bg-transparent h-14 top-0 left-0 z-40  w-screen bg-bg2 flex items-center justify-between headershadow ">
          <img
            className="object-cover h-[20px] pl-2 "
            src={getLogoBySubdomain(true)}
            alt=""
            onClick={() => {
              scrollToTop();
              navigate("/dashboard/dashboard");
              CommonStore.setBottomNavigationIndex(0);
            }}
          />
          <div className="  mr-2 flex justify-around items-center">
            {/* <IoChatbubbleEllipses
              onClick={() => {
                console.log("clicked");
                PopupStore.setConnectPopup(true);
              }}
            /> */}

            {/* <MdNotifications
              onClick={() => {
                PopupStore.setNotification(true);
              }}
              className="text-2xl"
            /> */}
            <img
              onClick={() => {
                navigate("/dashboard/settings");
                CommonStore.setBottomNavigationIndex(3);
              }}
              src={`${profile1 || defaultProfile}`}
              alt=" "
              className="w-[30px] h-[30px]    rounded-full "
              style={{
                backgroundImage: `url(${defaultProfile})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          </div>
        </div>
      </header>

      {/* <div className="h-12 p-0 m-0 top-0 bg-white"></div> */}
      <HelpCenter />
      {/* {CommonStore.bottomNavigationIndex === 0 && (
        home()
      )}
      {CommonStore.bottomNavigationIndex === 1 && (
        <div className="w-[95%] md:w-[75%] mx-auto mb-20 mt-32">
          <div className="">
            <MeetingCreationForm showMeeting={false} />
          </div>{" "}
          <div className="w-[100%]  flex justify-start font-bold text-text_color3 mx-auto text-[15px]">
            <div className="flex">
              <p
                className={`${
                  UserStore?.dashboardInterviews.length === 0
                    ? "pt-28"
                    : "pt-10"
                }`}>
                Recent Interviews
              </p>
            </div>
            <div className="flex w-[65%]  ">
              <p className="pt-10 pl-20 text-black">Total Interviews</p>
              <p className="text-primary text-xl pt-8 px-2 ">
                {UserStore?.dashboardInterviews?.length}
              </p>
            </div>
          </div>
          <PreviousInterview from="mobile" />{" "}
        </div>
      )}
      {CommonStore.bottomNavigationIndex === 9 && <CareerDetails />}
      {CommonStore.bottomNavigationIndex === 10 && <Career />}
      {CommonStore.bottomNavigationIndex === 8 && <Internship />}
      {CommonStore.bottomNavigationIndex === 11 && <CareerLanding />}
      {CommonStore.bottomNavigationIndex === 12 && <History />}
      {/* {CommonStore.bottomNavigationIndex === 13 && <JobPostReport job={job} />} */}
      {/* {CommonStore.bottomNavigationIndex === 2 && learn()}
      {CommonStore.bottomNavigationIndex === 3 && profile()}

      {CommonStore.bottomNavigationIndex === 5 && (
        <div className="w-full h-fit flex flex-col justify-center mt-44 items-center ">
          {" "}
          <MeetingCreationForm showMeeting={true} />{" "}
        </div>
      )}

      {CommonStore.bottomNavigationIndex === 6 && (
        <div className=" flex flex-col justify-center mt-0 md:mt-20 items-center h-full">
          <ReferAndEarnContent />
        </div>
      )}
      {CommonStore.bottomNavigationIndex === 7 && (
        <div className="pb-16 pt-4 mt-32 ">
          <ResumeDetails></ResumeDetails>{" "}
        </div>
      )}  */}

      <div className="fixed bottom-0 left-0 w-full !h-14 px-2 z-50 bg-black md:hidden meeting-form-shadow  square-t-lg">
        <div className="flex justify-around items-center">
          {/* <button
            className="focus:outline-none text-gray-500 hover:text-primary flex flex-col items-center justify-center"
            onClick={() => {
              scrollToTop();
              CommonStore.setBottomNavigationIndex(0);
            }}
          >
            <RiHome5Line
              size={28}
              className={`${
                CommonStore.bottomNavigationIndex === 0 ? "text-primary" : null
              }`}
            />
            <span
              className={`text-xs mt-1 ${
                CommonStore.bottomNavigationIndex === 0 ? "text-primary" : null
              }`}
            >
              Home
            </span>
          </button> */}
          {view("home") && (
            <button
              onClick={() => {
                scrollToTop();
                navigate("/dashboard/dashboard");
                CommonStore.setBottomNavigationIndex(0);
              }}
              className={`w-[20%] h-14 focus:outline-none text-gray-400 flex  flex-col items-center justify-center ${
                CommonStore.bottomNavigationIndex === 0
                  ? "text-primary bg-opacity-40"
                  : ""
              }`}
            >
              {CommonStore.bottomNavigationIndex !== 0 && (
                <GoHome
                  size={24}
                  // className={`opacity-70`}
                />
              )}
              {CommonStore.bottomNavigationIndex === 0 && (
                <GoHome
                  size={24}
                  //  className={``}
                />
              )}

              <span className={`text-xs mt-1 opacity-100`}>Home</span>
            </button>
          )}
          {view("resume") && (
            <button
              className={`w-[20%] h-14 focus:outline-none text-gray-400 flex flex-col items-center justify-center ${
                CommonStore.bottomNavigationIndex === 7
                  ? "text-primary bg-opacity-40"
                  : ""
              }`}
              onClick={() => {
                scrollToTop();
                navigate("/dashboard/resumedetails");
                CommonStore.setBottomNavigationIndex(7);
              }}
            >
              <IoDocumentTextOutline
                size={24}
                className={`${
                  CommonStore.bottomNavigationIndex === 7
                    ? "opacity-100"
                    : "opacity-70"
                }`}
              />
              <span className={`text-xs mt-1`}>Resume</span>
            </button>
          )}
          {/* <button
            className="focus:outline-none text-gray-500 hover:text-primary flex  flex-col items-center justify-center"
            onClick={() => {
              scrollToTop();
              CommonStore.setBottomNavigationIndex(1);
            }}
          >
            <AiOutlineUsergroupAdd
              size={28}
              className={`${
                CommonStore.bottomNavigationIndex === 1 ? "text-primary" : null
              }`}
            />
            <span
              className={`text-xs mt-1 ${
                CommonStore.bottomNavigationIndex === 1 ? "text-primary" : null
              }`}
            >
              Interviews
            </span>
          </button> */}
          {/* <div className="text-primary flex fixed h-fit ml-[25px] w-fit mt-[-42px] rounded-full flex-col items-center justify-center">
            <button
              className="focus:outline-none bg-white overflow-hidden rounded-full"
              onClick={() => {
                scrollToTop();
                PopupStore.setCreateInterview(true);
              }}
            >
              <BiPlus
                size={50}
                className="border-[5px] bg-primary text-white border-[#FFBD8E] rounded-full"
              />
            </button>
            <span className="text-xs mt-1 text-center">
              Create
              <br />
              Interview
            </span>
          </div> */}
          {view("Career") && (
            <button
              onClick={() => {
                scrollToTop();
                navigate("/dashboard/jobinternship");
                CommonStore.setBottomNavigationIndex(8);
              }}
              className={`w-[20%] h-14 focus:outline-none text-gray-400  flex  flex-col items-center justify-center ${
                CommonStore.bottomNavigationIndex === 8 ||
                CommonStore.bottomNavigationIndex === 11 ||
                CommonStore.bottomNavigationIndex === 10 ||
                CommonStore.bottomNavigationIndex === 9
                  ? "text-primary bg-opacity-40"
                  : ""
              }`}
            >
              {CommonStore.bottomNavigationIndex !== 8 && (
                <PiSuitcaseSimpleLight
                  size={24}
                  // className={`opacity-70`}
                />
              )}
              {CommonStore.bottomNavigationIndex === 8 && (
                <PiSuitcaseSimpleLight
                  size={24}
                  // className={`opacity-100`}
                />
              )}

              <span className={`text-xs mt-1`}>Jobs</span>
            </button>
          )}
          {view("refer") && (
            <button
              onClick={() => {
                scrollToTop();
                navigate("/dashboard/applications");
                CommonStore.setBottomNavigationIndex(12);
              }}
              className={`w-[20%] h-14 focus:outline-none text-gray-400 flex flex-col items-center justify-center ${
                CommonStore.bottomNavigationIndex === 12 ||
                CommonStore.bottomNavigationIndex === 13
                  ? " text-primary bg-opacity-40"
                  : ""
              }`}
            >
              <VscHistory
                size={24}
                className={`${
                  CommonStore.bottomNavigationIndex === 12
                  // ? "opacity-100"
                  // : "opacity-60"
                }`}
              />
              <span className={`text-xs mt-1`}>My jobs</span>
            </button>
          )}
          {/* {view("learn") && (
            <button
              onClick={() => {
                scrollToTop();
                navigate("/dashboard/learn");
                CommonStore.setBottomNavigationIndex(2);
              }}
              className={`w-[20%] h-16 focus:outline-none text-gray-400  flex  flex-col items-center justify-center ${
                CommonStore.bottomNavigationIndex === 2
                  ? " text-primary bg-opacity-40"
                  : ""
              }`}
            >
              {CommonStore.bottomNavigationIndex !== 2 && (
                <AiOutlineRead size={28} className={`opacity-70`} />
              )}
              {CommonStore.bottomNavigationIndex === 2 && (
                <AiOutlineRead size={28} className={`opacity-100`} />
              )}

              <span className={`text-xs mt-1`}>Learn</span>
            </button>
          )} */}
          {view("profile") && (
            <button
              onClick={() => {
                scrollToTop();
                navigate("/dashboard/settings");
                CommonStore.setBottomNavigationIndex(2);
              }}
              className={`w-[20%] h-14 focus:outline-none text-gray-400  flex  flex-col items-center justify-center ${
                CommonStore.bottomNavigationIndex === 2
                  ? " text-primary bg-opacity-40"
                  : ""
              }`}
            >
              {CommonStore.bottomNavigationIndex !== 2 && (
                <IoSettingsOutline
                  size={24}
                  //  className={`opacity-70`}
                />
              )}
              {CommonStore.bottomNavigationIndex === 2 && (
                <IoSettingsOutline
                  size={24}
                  //  className={`opacity-100`}
                />
              )}

              <span className={`text-xs mt-1`}>Settings</span>
            </button>
          )}
        </div>
      </div>
      <div className="">
        <Routes className="router-parent">
          <Route path="/" element={home()} />
          <Route path="/dashboard" element={home()} />
          <Route path="/settings" element={profile()} />
          <Route path="/learn" element={learn()} />
          <Route path="/resume" element={<ResumeDetails />} />
          <Route path="/mocktest" element={<CreateMockTest />} />
          <Route path="/resumedetails" element={<ResumeTotal />} />
          <Route path="/resumetemplets" element={<ResumeTotal />} />
          <Route path="/career" element={<CareerLanding />} />
          <Route path="/myapplicants" element={<History />} />
          <Route path="/myapplicants/:id" element={<History />} />
          <Route
            path="/applications"
            element={<HistoryPage />}
            children={<Route path="*" element={<HistoryPage />} />}
          />
          <Route path="/career-details" element={<CareerDetails />} />
          <Route path="/career-info/:tech" element={<Career />} />
          <Route
            path="/meeting-creation-form"
            element={<MeetingCreationForm />}
          />
          <Route path="/resume-analyzer" element={<ResumeAnalyzer />} />
          <Route path="/resume-analyzer-report" element={<Report />} />

          <Route
            path="/JobInternship/*"
            element={<Internship />}
            children={<Route path="*" element={<Internship />} />}
          />
          <Route path="/JobInternship/job-post/:id" element={<JobDetails />} />
          {/* <Route path="/settings" element={<div>profile</div>} /> */}
          <Route path="/report/:id" element={<ReportScreen />} />
          <Route path="/course/:id" element={<LearninngTab hide={"false"} />} />
          <Route path="/mockexamreport" element={<MockExamReport />} />
          <Route
            path="/pricing-plan"
            element={<PricingPlan isStudent1={true} />}
          />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route
            path="/subscription"
            element={
              <Subscription commingFrom={"student"} plans={studentPlans} />
            }
          />
          <Route
            path="/subscription/successfull"
            element={<TransactionCards status={"success"} />}
          />
          <Route
            path="/subscription/failure"
            element={<TransactionCards status={"failure"} />}
          />
          <Route
            path="/subscription/pending"
            element={<TransactionCards status={"pending"} />}
          />
        </Routes>
      </div>
      {/* {CommonStore.bottomNavigationIndex !== 7 && <HelpCenter className={"bottom-[8vh]"}/>} */}

      {/* {CommonStore.bottomNavigationIndex === 1 ? (
        <div
          onClick={() => CommonStore.setBottomNavigationIndex(5)}
          className="bg-primary h-12 w-12 text-white rounded-full p-2 cursor-pointer fixed bottom-[8vh] mx-auto right-4 z-50"
        >
          <AiOutlineUserAdd className="w-7 h-7" />
        </div>
      ) : (
        <HelpCenter className={"bottom-[8vh]"} />
      )} */}
    </div>
  ));
};

export default MobileBottomNavBar;
